import { render, staticRenderFns } from "./DialogPromoPanoramica.vue?vue&type=template&id=13b799be&scoped=true&"
import script from "./DialogPromoPanoramica.vue?vue&type=script&lang=js&"
export * from "./DialogPromoPanoramica.vue?vue&type=script&lang=js&"
import style0 from "./DialogPromoPanoramica.vue?vue&type=style&index=0&id=13b799be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b799be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13b799be')) {
      api.createRecord('13b799be', component.options)
    } else {
      api.reload('13b799be', component.options)
    }
    module.hot.accept("./DialogPromoPanoramica.vue?vue&type=template&id=13b799be&scoped=true&", function () {
      api.rerender('13b799be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/DialogPromoPanoramica.vue"
export default component.exports